/**
 * Utility to clear all caches and storage
 */
export const clearAllCache = async () => {
  console.log('🧹 Starting cache cleanup...');
  
  try {
    // 1. Clear localStorage
    localStorage.clear();
    console.log('✅ localStorage cleared');
    
    // 2. Clear sessionStorage
    sessionStorage.clear();
    console.log('✅ sessionStorage cleared');
    
    // 3. Clear all cookies for localhost
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    console.log('✅ Cookies cleared');
    
    // 4. Clear IndexedDB
    if ('indexedDB' in window) {
      const databases = await indexedDB.databases();
      await Promise.all(
        databases.map(db => {
          if (db.name) {
            indexedDB.deleteDatabase(db.name);
          }
        })
      );
      console.log('✅ IndexedDB cleared');
    }
    
    // 5. Unregister service workers
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(
        registrations.map(registration => registration.unregister())
      );
      console.log('✅ Service workers unregistered');
    }
    
    // 6. Clear CacheStorage
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(
        cacheNames.map(cacheName => caches.delete(cacheName))
      );
      console.log('✅ CacheStorage cleared');
    }
    
    // 7. Clear Supabase specific storage
    const supabaseKeys = Object.keys(localStorage).filter(key => 
      key.includes('supabase') || key.includes('auth')
    );
    supabaseKeys.forEach(key => localStorage.removeItem(key));
    
    console.log('🎉 All caches cleared successfully!');
    return true;
  } catch (error) {
    console.error('❌ Error clearing cache:', error);
    return false;
  }
};

/**
 * Force reload with cache bypass
 */
export const forceReload = () => {
  // Add timestamp to force cache bypass
  const timestamp = new Date().getTime();
  const url = new URL(window.location.href);
  url.searchParams.set('_t', timestamp.toString());
  
  // Hard reload
  window.location.href = url.toString();
};
